import React, { useEffect, useState } from 'react';
import { Modal } from './Modal';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void | Promise<void>;
  title: string;
  message: React.ReactNode;
  confirmLabel?: string;
  cancelLabel?: string;
  danger?: boolean;
  /** Quando presente, o usuário precisa digitar exatamente esse texto no campo
   *  para o botão de confirmar habilitar. Usado em ações destrutivas fortes
   *  (remoção de empresa, por exemplo). */
  requireText?: string;
  /** Rótulo do campo quando requireText está presente. */
  requireLabel?: string;
}

export default function ConfirmDialog({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmLabel = 'Confirmar',
  cancelLabel = 'Cancelar',
  danger = false,
  requireText,
  requireLabel = 'Digite para confirmar'
}: Props) {
  const [typed, setTyped] = useState('');
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!isOpen) {
      setTyped('');
      setBusy(false);
    }
  }, [isOpen]);

  const canConfirm = !busy && (!requireText || typed.trim() === requireText);

  const handleConfirm = async () => {
    if (!canConfirm) return;
    setBusy(true);
    try {
      await onConfirm();
      onClose();
    } finally {
      setBusy(false);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      maxWidth="480px"
      footer={
        <>
          <button className="btn btn-secondary btn-sm" onClick={onClose} disabled={busy}>
            {cancelLabel}
          </button>
          <button
            className={danger ? 'btn btn-danger' : 'btn btn-primary'}
            onClick={handleConfirm}
            disabled={!canConfirm}
            style={{ marginLeft: 8 }}
          >
            {busy ? 'Processando…' : confirmLabel}
          </button>
        </>
      }
    >
      <div style={{ fontSize: 14, lineHeight: 1.5 }}>{message}</div>
      {requireText && (
        <div className="field" style={{ marginTop: 12 }}>
          <label>{requireLabel}</label>
          <input
            className="input"
            value={typed}
            onChange={(e) => setTyped(e.target.value)}
            autoFocus
            placeholder={requireText}
          />
        </div>
      )}
    </Modal>
  );
}
